import s from './Select.module.css';
import { SelectProps } from '@/types/model';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import cs from 'classnames';

const Select = ({ handleChange, options, value, inputName, small }: SelectProps) => {
  const selectLabel = options?.find((option) => option.value === 'default')?.label || inputName;

  return (
    <div className={s.container}>
      <ReactSVG
        className={s.container__arrow}
        src="/icons/arrow-icon.svg"
        beforeInjection={hideDecorativeSvg}
      />
      <select
        className={cs(s.container__input, { [s.container__input__small]: small })}
        value={value}
        id={inputName}
        name={inputName}
        onChange={handleChange}
        aria-label={selectLabel}>
        {options &&
          options.map((option) => {
            if (option.value === 'default') {
              return (
                <option key={option.value} value={option.value} disabled>
                  {option.label}
                </option>
              );
            } else {
              return (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              );
            }
          })}
      </select>
    </div>
  );
};

export default Select;
